module.exports = __webpack_public_path__ + "media/images/plans/plan-detail-photo-toast-alcohol-dbde5601ab64220cf57771bcb93bd854.jpg";